import { useEffect, useState } from "react";
import { validateEmailFormat } from "../utils/validationUtils";
import { CustomerFormData } from "src/shared/services/interfacev2";

interface Phone {
  phone: string;
  isPrimary?: boolean;
}

interface Email {
  email: string;
  isPrimary?: boolean;
}

interface OriginalCustomerData {
  firstName: string;
  middleName: string;
  lastName: string;
  phone: string;
  alternativePhone: string;
  email: string;

  phones: Phone[];
  emails: Email[];

  address: string;
  address2: string;
  address3: string;
  address4: string;
}

interface UseCustomerValidationProps {
  formData: CustomerFormData;
  originalData: OriginalCustomerData;
}

export const useCustomerValidation = ({
  formData,
  originalData,
}: UseCustomerValidationProps) => {
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const isDataChanged =
      formData.firstName !== originalData.firstName ||
      formData.middleName !== originalData.middleName ||
      formData.lastName !== originalData.lastName ||
      formData.phone !== originalData.phone ||
      formData.alternativePhone !== originalData.alternativePhone ||
      formData.email !== originalData.email ||
      formData.address !== originalData.address ||
      formData.address2 !== originalData.address2 ||
      formData.address3 !== originalData.address3 ||
      formData.address4 !== originalData.address4;

    const hasRequiredFields =
      formData.firstName.trim() !== "" &&
      formData.phone.trim().length >= 8 &&
      (formData.email === "" || validateEmailFormat(formData.email));

    setIsFormValid(isDataChanged && hasRequiredFields);
  }, [formData, originalData]);

  const validateForm = async () => {
    if (!formData.firstName.trim()) return false;
    if (!formData.phone.trim() || formData.phone.length < 8) return false;

    if (
      formData.email.trim() !== "" &&
      !validateEmailFormat(formData.email)
    ) {
      return false;
    }

    return true;
  };

  return {
    validateForm,
    isFormValid,
  };
};
